import BugsnagErrorHandler from 'bugsnag-angular';
import bugsnag from 'bugsnag-js';

const bugsnagClient = bugsnag('1618ff1235d864eb552ca1c4b560bdd8');

export function errorHandlerFactory() {
    return new BugsnagErrorHandler(bugsnagClient)
}

// Angular & Other 3rd Party packages

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {NgModule, APP_INITIALIZER, ErrorHandler, Injectable, Inject} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ProgressBarModule } from "angular-progress-bar";
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { NgSpinKitModule } from 'ng-spin-kit';
import { MomentModule } from 'ngx-moment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { CalendarModule } from 'primeng/calendar';
import { DeviceDetectorModule } from 'ngx-device-detector'
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { DragulaModule } from 'ng2-dragula';

//Custom Components & Services

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { SendMsg } from './Components/SendMsg/SendMsg';
import { HomeComponent } from './home/home.component';
import { MasterDataService } from './Services/MasterDataService';
import { APIServiceConnector } from './Services/APIServiceConnector';
import { AppSettings } from './Library/AppSettings';
import { UserService } from './Services/UserService';
import { RegisterCall } from './Components/RegisterCall/RegisterCall';
import { PMSService } from './Services/PMSService';
import { PMSSignalRService } from './Services/PMSSignalRService';
import { ErrorSummary } from './Library/ErrorSummary';
import { ConsoleHeaderOffsetDirective } from './Library/ConsoleHeaderOffsetDirective';
import { ComplainService } from './Services/ComplainService';
import { GuestDetail } from './Components/GuestDetail/GuestDetail';
import { PendingCalls } from './Components/PendingCalls/PendingCalls';
import { RegisterGlitch } from './Components/RegisterGlitch/RegisterGlitch';
import { RecurrenceConsole } from './Components/RecurrenceConsole/RecurrenceConsole';
import { RecurrenceConsoleService } from './Services/RecurrenceConsoleService';
import { ManualAssign } from './Components/ManualAssign/ManualAssign';
import { GSRAudit } from './Components/GSRAudit/GSRAudit';
import { CallAttachment } from './Components/CallAttachment/CallAttachment';
import { StaffJobList } from './Components/StaffJobList/StaffJobList';
import { RecurrenceUpdate } from './Components/RecurrenceUpdate/RecurrenceUpdate';
import { ParkEntry } from './Components/ParkEntry/ParkEntry';
import { JobConsole } from './Components/JobConsole/JobConsole';
import { RecurrenceFilter } from './Components/RecurrenceFilter/RecurrenceFilter';
import { JobPopover } from './Components/JobPopover/JobPopover';
import { JobFilter } from './Components/JobFilter/JobFilter';
import { JobFilterInner } from './Components/JobFilterInner/JobFilterInner';
import { JobOperations } from './Components/JobOperations/JobOperations';
import { ShiftSetUp } from './Components/ShiftSetUp/ShiftSetUp';
import { ShiftSetUpService } from './Services/ShiftSetUpService';
import { Department } from './Components/Department/Department';
import { StaffSkillSectionMap } from './Components/StaffSkillSectionMap/StaffSkillSectionMap';
import { SectionList } from './Components/SectionList/SectionList';
import { SkillList } from './Components/SkillList/SkillList';
import { RecurrencePopover } from './Components/RecurrencePopover/RecurrencePopover';
import { JobSearchResult } from './Components/JobSearchResult/JobSearchResult';
import { JobSearchGroup } from './Components/JobSearchGroup/JobSearchGroup';
import { SectionLocation } from './Components/SectionLocation/SectionLocation';
import { DeviceDetail } from './Components/DeviceDetail/DeviceDetail';
import { AddEditStaffDevice } from './Components/AddEditStaffDevice/AddEditStaffDevice';
import { SecureImage } from './Services/SecureImage';
import { ComplainSignalRService } from './Services/ComplainSignalRService';
import { AddNotes } from './Components/AddNotes/AddNotes';
import { CurrentReservationConsole } from './Components/CurrentReservationConsole/CurrentReservationConsole';
import { ShiftStaffInOut } from './Components/ShiftStaffInOut/ShiftStaffInOut';
import { NotificationCenter } from './Components/NotificationCenter/NotificationCenter';
import { MessagingService } from './Services//MessagingService';
import { DeleteObject } from './Components/DeleteObject/DeleteObject';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { UserProfile } from './Components/UserProfile/UserProfile';
import { ShiftDetail } from './Components/ShiftDetail/ShiftDetail';
import { ChangePassword } from './Components/ChangePassword/ChangePassword';
import { MultipleLoginLogout } from './Components/MultipleLoginLogout/MultipleLoginLogout';
import { MessagingSignalRService } from './Services/MessagingSignalRService';
import { MessageDetail } from './Components/MessageDetail/MessageDetail';
import { Inbox } from './Components/Inbox/Inbox';
import { TagStaff } from './Components/TagStaff/TagStaff';
import { OpenJobsInformation } from './Components/OpenJobsInformation/OpenJobsInformation';
import { SessionsSignalRService } from './Services/SessionsSignalRService';
import { UploadImage } from './Components/UploadImage/UploadImage';
import { Configuration } from './Components/Configuration/Configuration';
import { JobSearchResult_Compact } from './Components/JobSearchResult_Compact/JobSearchResult_Compact';
import { JobConsole_Compact } from './Components/JobConsole_Compact/JobConsole_Compact';
import { GlitchConsole_Compact } from './Components/GlitchConsole_Compact/GlitchConsole_Compact';
import { GlitchService } from './Services/GlitchService';
import { GlitchConsole } from './Components/GlitchConsole/GlitchConsole';
import { GlitchSearchGroup } from './Components/GlitchSearchGroup/GlitchSearchGroup';
import { GlitchSearchResult } from './Components/GlitchSearchResult/GlitchSearchResult';
import { GlitchPopover } from './Components/GlitchPopover/GlitchPopover';
import { VisitorSearchPopup } from './Components/VisitorSearchPopup/VisitorSearchPopup';
import { AuthGuardService } from './Services/AuthGuardService';
import { GuestSearchPopup } from './Components/GuestSearchPopup/GuestSearchPopup';
import { GlitchAction } from './Components/GlitchAction/GlitchAction';
import * as enumModels from './Models/EnumModels';
import { WelcomeScreen } from './Components/WelcomeScreen/WelcomeScreen';
import { QrCode } from './Components/QrCode/QrCode';
import { DeviceConsole } from './Components/DeviceConsole/DeviceConsole';
import { DeviceSearchResult } from './Components/DeviceSearchResult/DeviceSearchResult';
import { DeviceService } from './Services/DeviceService';
import { QrCodeService } from './Services/QrCodeService';
import { AddEditQuestionSetComponent } from './Components/add-edit-question-set/add-edit-question-set.component'
import { StaffHealthDataService } from './Services/StaffHealthDataService';
import { QuestionInput } from './Components/QuestionInput/QuestionInput';
import { QuestionResponseConfiguration } from './Components/QuestionResponses/QuestionResponseConfiguration';
import { QuestionResponseView } from './Components/QuestionResponses/QuestionResponseView';
import { QuestionnaireConsole } from './Components/QuestionnaireConsole/QuestionnaireConsole';
import { QuestionnairePopover } from './Components/QuestionnairePopover/QuestionnairePopover';
import { QuestionnaireSearchResult } from './Components/QuestionnaireSearchResult/QuestionnaireSearchResult';
import { SelectPMSDates } from './Components/SelectPMSDates/SelectPMSDates';
import { ValueFilterPipe } from './Components/Pipes/ValueFilterPipe';
import { RemarksPopup } from './Components/RemarksPopup/RemarksPopup';
import { RemarksPopupTrigger } from './Components/RemarksPopup/RemarksPopupTrigger';
import {PaginatedRecurrenceConsole} from "./Components/RecurrenceConsole_Paginated/PaginatedRecurrenceConsole";
import {RecurrenceSearchResult} from "./Components/RecurrenceSearchResult/RecurrenceSearchResult";
import {RecurrenceSearchGroup} from "./Components/RecurrenceSearchGroup/RecurrenceSearchGroup";
import {PropertyDateTimeFormatPipe} from "./Components/Pipes/PropertyDateTimeFormatPipe";
import { AnalyticsComponent } from './Components/Analytics/analytics.component';
import {UFBootstrapService} from "./Services/UFBootstrapService";

export function initConfiguration(
    configService: MasterDataService,
    pmsService: PMSService,
    pmsSignalRService: PMSSignalRService,
    complainSignalRService: ComplainSignalRService,
    messagingService: MessagingService,
    messagingSignalRService: MessagingSignalRService,
    sessionsSignalRService: SessionsSignalRService,
    userService: UserService,
    glitchService: GlitchService,
    qrCodeService : QrCodeService,
    ufBootstrapService: UFBootstrapService): Function {
    return () => {
        return ufBootstrapService
            .bootstrapApplicationEnvironment()
            .then(() => configService.InitializeClientConfig())
            .then(() => {
                pmsService.BaseURL = AppSettings.URL_PMSService;
                pmsSignalRService.BaseURL = AppSettings.URL_PMSService;
                complainSignalRService.BaseURL = AppSettings.URL_ComplainService;
                messagingService.BaseURL = AppSettings.URL_Messaging;
                messagingSignalRService.BaseURL = AppSettings.URL_Messaging;
                sessionsSignalRService.BaseURL = AppSettings.URL_Session;
                userService.BaseURL = AppSettings.URL_Users;
                userService.URL_WorkOrders = AppSettings.URL_WorkOrders;
                glitchService.BaseURL = AppSettings.URL_GlitchService;
                try {
                    console.log('is running in iframe: ', ufBootstrapService.isRunningInIframe());
                    console.log('is running in singularity: ', ufBootstrapService.isRunningInSingularity());
                    AppSettings.IsRunningInSingularity = ufBootstrapService.isRunningInIframe() && ufBootstrapService.isRunningInSingularity();
                } catch (error) {
                    console.error('error finding runtime:', error);
                }
            })
            .then(() => configService.RefreshToken())
            .then(() => Promise.all([
                configService.InitializeStartupData(),
                pmsService.GuestLookup_Get(null)
            ]))
            .then(() => configService.InitializeMNTStartupData())
            .then(() => {
                pmsSignalRService.Init();
                complainSignalRService.Init();
                messagingSignalRService.Init();
                sessionsSignalRService.Init();
                qrCodeService.setQrCodeFeature();
                qrCodeService.Init();
                qrCodeService.validateIdentifierToken();
            })
    }
}

export function HttpLoaderFactory(http: HttpClient, master: MasterDataService): any {
    return new TranslateHttpLoader(http, AppSettings.URL_Masters + 'OpenAPI/GetStaticUILabelsForWeb?PropertyID=' + master.LoggedInUserData.PropertyId + '&LanguageCode=', '');
}

@NgModule({
    declarations: [
        AppComponent,
        ConsoleHeaderOffsetDirective,
        NavMenuComponent,
        SendMsg,
        HomeComponent,
        RegisterCall,
        GuestDetail,
        PendingCalls,
        ErrorSummary,
        RegisterGlitch,
        RecurrenceConsole,
        ManualAssign,
        GSRAudit,
        CallAttachment,
        StaffJobList,
        RecurrenceUpdate,
        ParkEntry,
        JobConsole,
        RecurrenceFilter,
        JobPopover,
        JobFilter,
        JobFilterInner,
        JobOperations,
        ShiftSetUp,
        Department,
        StaffSkillSectionMap,
        SectionList,
        SkillList,
        RecurrencePopover,
        JobSearchResult,
        JobSearchGroup,
        SectionLocation,
        DeviceDetail,
        AddEditStaffDevice,
        SecureImage,
        CurrentReservationConsole,
        AddNotes,
        ShiftStaffInOut, NotificationCenter,
        DeleteObject,
        UserProfile,
        ShiftDetail,
        ChangePassword,
        Configuration,
        MultipleLoginLogout,
        MessageDetail,
        Inbox, TagStaff,
        OpenJobsInformation,
        UploadImage, JobSearchResult_Compact, JobConsole_Compact, GlitchConsole_Compact, GlitchSearchGroup, GlitchSearchResult, GlitchConsole, GlitchPopover, GuestSearchPopup,
        VisitorSearchPopup,
        GlitchAction,
        WelcomeScreen,
        QrCode,
        DeviceConsole,
        DeviceSearchResult,
        AddEditQuestionSetComponent,
        QuestionInput,
        QuestionResponseConfiguration,
        QuestionResponseView,
        QuestionnaireConsole,
        QuestionnairePopover,
        QuestionnaireSearchResult,
        SelectPMSDates,
        ValueFilterPipe,
        PropertyDateTimeFormatPipe,
        RemarksPopup,
        RemarksPopupTrigger,
        PaginatedRecurrenceConsole,
        RecurrenceSearchResult,
        RecurrenceSearchGroup,
        AnalyticsComponent
    ],
    imports: [
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        DragulaModule.forRoot(),
        NgSelectModule,
        NgSpinKitModule,
        MomentModule,
        ProgressBarModule,
        CalendarModule,
        NgbModule.forRoot(),
        Ng4LoadingSpinnerModule.forRoot(),
        VirtualScrollerModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-center'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient, MasterDataService]
            }
        }),
        NgxMaskModule.forRoot(),
        RouterModule.forRoot([
            { path: '', component: QrCode, pathMatch: 'full', data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'Qr Code' } },
            // { path: '', redirectTo: 'home', pathMatch:'full' },

        ]),
        RouterModule.forChild([
            { path: 'home', component: HomeComponent,
            children:[
                { path: '', component: JobConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_JOB_CONSOLE' } },
                { path: 'Calls/JobConsole', component: JobConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_JOB_CONSOLE' } },
                { path: 'Calls/RegisterCall', component: RegisterCall, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_NEW_JOB' } },

                { path: 'Glitch/RegisterGlitch', component: RegisterGlitch, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.Glitch, ScreenName: 'NAV.NAV_NEW_GLITCH' } },
                { path: 'Glitch/GlitchConsole', component: GlitchConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.Glitch, ScreenName: 'NAV.NAV_GLITCH_CONSOLE' } },

                { path: 'RecurrenceJob/Console', component: RecurrenceConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_REC_CONSOLE' } },
                { path: 'RecurrenceJob/NewConsole', component: PaginatedRecurrenceConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_REC_CONSOLE' } },
                { path: 'Shift/ShiftSetUp', component: ShiftSetUp, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_SHIFT_SETUP' } },

                { path: 'Glitch/Analytics', component: AnalyticsComponent, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.GlitchAnalytics, ScreenName: 'NAV.NAV_GLITCH_ANALYTICS' } },
                { path: 'Service/Analytics', component: AnalyticsComponent, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.ServiceAnalytics, ScreenName: 'NAV.NAV_SERVICE_ANALYTICS' } },
                { path: 'HK/Analytics', component: AnalyticsComponent, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.HKAnalytics, ScreenName: 'NAV.NAV_HK_ANALYTICS' } },
                { path: 'Guests/CurrentReservationConsole', component: CurrentReservationConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.Guests, ScreenName: 'NAV.NAV_GUESTS' } },

                { path: 'StaffHealth/RegisterQuestionSet', component: AddEditQuestionSetComponent, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.StaffHealth, ScreenName: 'NAV.NAV_NEW_QUESTIONNAIRE' } },
                { path: 'StaffHealth/QuestionnaireConsole', component: QuestionnaireConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.StaffHealth, ScreenName: 'NAV.NAV_QUESTIONNAIRES' } },

                { path: 'Inbox/Inbox', component: Inbox, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_INBOX' } },
                { path: 'Devices', component: DeviceConsole, canActivate: [AuthGuardService], data: { SelectedModule: enumModels.Modules.NoService, ScreenName: 'NAV.NAV_KNOWCROSS_WEB_AUTH_CONSOLE' } },
                { path: 'Welcome', component: WelcomeScreen }
            ]
        },
        ]),
        ModalDialogModule.forRoot(),
        DeviceDetectorModule.forRoot(),
        NgxQRCodeModule
    ],

    providers: [
        APIServiceConnector,
        UserService,
        PMSService,
        PMSSignalRService,
        MasterDataService,
        RecurrenceConsoleService,
        ComplainService,
        DeviceService,
        ComplainSignalRService,
        MessagingService,
        ShiftSetUpService,
        GlitchService,
        AuthGuardService,
        QrCodeService,
        CookieService,
        StaffHealthDataService,
        UFBootstrapService,

        { provide: ErrorHandler, useFactory: errorHandlerFactory },
        {
            'provide': APP_INITIALIZER,
            'useFactory': initConfiguration,
            'deps': [
                MasterDataService,
                PMSService,
                PMSSignalRService,
                ComplainSignalRService,
                MessagingService,
                MessagingSignalRService,
                SessionsSignalRService,
                UserService,
                GlitchService,
                QrCodeService,
                UFBootstrapService
            ],
            'multi': true,
        },
    ],
    entryComponents: [JobFilterInner, QuestionResponseConfiguration, RemarksPopup],
    bootstrap: [AppComponent]
})

export class AppModule { }
